import {
  initialState,
  Actions,
  State,
  GET_SUBSCRIBER_VIEWS,
  GET_SUBSCRIBER_VIEWS_SUCCESS,
  GET_SUBSCRIBER_VIEWS_ERROR,
  RESET_SUBSCRIBER_VIEWS,
} from "../../types/post-views/get-subscriber-views";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_SUBSCRIBER_VIEWS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_SUBSCRIBER_VIEWS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_SUBSCRIBER_VIEWS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_SUBSCRIBER_VIEWS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;

